import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import serviceToCalculateGenerator from '@pages/AdditionalServices/containers/services/serviceToCalculateGenerator';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';
import { servicesServicesService } from '@services/requests/servicesService/servicesServicesService';
import { ServicesServicePriceCalculationMutationProps } from '@services/requests/servicesService/servicesServicesService/interface';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * CalculationResultProcessor формирует расчеты для каждой услуги в каждом варианте
 */
export class CalculationResultProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const servicesToCalculate = additionalServiceState.Variants.map((v) => ({
      variant: v,
      services: additionalServiceState.VariantServices[v.id]
        .map((s) => [s, ...s.additionServices])
        .flat(1)
        .map((s) =>
          serviceToCalculateGenerator().Generate(
            s,
            additionalServiceState.CurrencyID,
            additionalServiceState.FieldValues,
            additionalServiceState.VariantFieldValues[v.id],
            additionalServiceState.ServiceTemplateStore[v.id][s.id]
          )
        )
        .flat(1),
    }));

    const result = await Promise.all(
      servicesToCalculate.map(async (data) => {
        return {
          variant: data.variant,
          result: await servicesServicesService().ServicePriceCalculation(data.services),
        };
      })
    );

    const filledCalculationResult: {
      [T in string]: ServicesServicePriceCalculationMutationProps[];
    } = {};
    result.map((v) => {
      filledCalculationResult[v.variant.id] = v.result;
    });

    return {
      isValid: true,
      additionalServiceState: {
        ...additionalServiceState,
        IsNeedCalculateServices: true,
        LastServiceCalculationID: '',
        VariantsCalculationResult: filledCalculationResult,
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
